import { InjectionToken } from '@angular/core';

export const PBF_TOKEN = new InjectionToken('PBF_TOKEN');
export const API_SERVICE_TOKEN = new InjectionToken('API_SERVICE_TOKEN');
export const ROLE_SERVICE_TOKEN = new InjectionToken('ROLE_SERVICE_TOKEN');

